export default __webpack_public_path__ + "img/2a96187057f0d6c4277a49be08ec9385.svg";